import { render, staticRenderFns } from "./CreateLeague.vue?vue&type=template&id=b55c7d38&"
import script from "./CreateLeague.vue?vue&type=script&lang=js&"
export * from "./CreateLeague.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports